import { createAxiosClient } from '@sophocles/axiosInit/factory';
import { API_URL, VANTAGE_API_URL } from '@sophocles/config';
import { refreshToken } from '@sophocles/features/auth/authActions';
import { selectSocketId } from '@sophocles/socket-io/slice';

let apiClient;
let vantageApiClient;

export function initializeApiClients(store) {
  apiClient = createAxiosClient(store, {
    baseURL: API_URL,
    onUnauthenticated: () => store.dispatch(refreshToken()),
    socketId: () => selectSocketId(store.getState()),
  });

  vantageApiClient = createAxiosClient(store, {
    baseURL: VANTAGE_API_URL,
    onUnauthenticated: () => store.dispatch(refreshToken()),
    socketId: () => selectSocketId(store.getState()),
  });
}

const apiClientProxy = new Proxy(
  {},
  {
    get(target, prop) {
      if (!apiClient) {
        throw new Error('API client not initialized. Call initializeApiClients(store) first.');
      }
      return apiClient[prop];
    },
  },
);

const vantageApiClientProxy = new Proxy(
  {},
  {
    get(target, prop) {
      if (!vantageApiClient) {
        throw new Error('Vantage API client not initialized. Call initializeApiClients(store) first.');
      }
      return vantageApiClient[prop];
    },
  },
);

export function getApiClient() {
  return apiClientProxy;
}

export function getVantageApiClient() {
  return vantageApiClientProxy;
}
